import { Button, Flex, Heading, Input } from "@chakra-ui/react";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { CustomizedTable } from "../../components/Common/Table/index";
import Notification from "../../components/Common/Notification/index";
import BasicLayout from "../../components/Layouts/BasicLayout";
import {
  deleteMainOrder,
  getMainOrders,
} from "../../store/actions/mainOrder/mainOrder.action";
import { updatePantOrder } from "../../store/actions/pantOrder/pantOrder.action";
import { updateShirtOrder } from "../../store/actions/shirtOrder/shirtOrder.action";

const Order = () => {
  const Orders = useSelector((state) => state?.mainorder?.mainorders);
  const dispatch = useDispatch();
  const [searchTerm, setSearchTerm] = useState("");

  useEffect(() => {
    async function fetchData() {
      await dispatch(getMainOrders());
    }
    fetchData();
  }, [dispatch]);

  const sortedActivities = Orders.sort(
    (a, b) => new Date(b.created_at) - new Date(a.created_at)
  );
  let filteredData = sortedActivities.filter((data) => {
    return data?.customer?.name
      .toLowerCase()
      .includes(searchTerm.toLowerCase()) ||
      data?.customer?.phonenumber
        .toString()
        .toLowerCase()
        .includes(searchTerm.toLowerCase())
      ? data
      : null;
  });
  let data = filteredData?.map((data) => {
    return Object.assign({}, data, {
      ids: data?.id || "",
      name: data?.customer?.name || "",
      phonenumber: data?.customer?.phonenumber || "",
      pantorders: data?.pantorders?.length || 0,
      shirtorders: data?.shirtorders?.length || 0,
    });
  });

  const columns = [
    { Header: "क्रमांक", accessor: "ids" },
    { Header: "नाव", accessor: "name" },
    { Header: "दूरध्वनी", accessor: "phonenumber" },
    { Header: "पॅंट", accessor: "pantorders" },
    { Header: "शर्ट", accessor: "shirtorders" },
    {
      Header: "क्रिया",
      accessor: "id",
      Cell: ({ cell: { value } }) => (
        <>
          <Link
            to={`order/${value}`}
            style={{ fontWeight: "bold", color: "#3182ce", fontSize: "18px" }}
          >
            पहा
          </Link>
        </>
      ),
    },
  ];

  // TO Select Row From Table And Do action on it
  let rowsToDelete = [];
  const selectId = async (data) => {
    rowsToDelete = [];
    data?.map((data) => {
      rowsToDelete.push(data);
      return null;
    });
  };
  const handleDelete = async () => {
    try {
      const SelectedOrders = await Orders.filter((order) => {
        function temp() {
          for (let i = 0; i < rowsToDelete.length; i++) {
            if (order?.id?.toString() === rowsToDelete[i]?.toString()) {
              return order;
            }
          }
        }
        return temp();
      });
      for (let a = 0; a < SelectedOrders.length; a++) {
        const pantOrders = SelectedOrders[a]?.pantorders?.map(
          (data) => data.id
        );
        if (pantOrders && pantOrders?.length > 0) {
          for (let i = 0; i < pantOrders?.length; i++) {
            await dispatch(
              updatePantOrder(pantOrders[i], {
                isAssigned: false,
                isActive: true,
              })
            );
          }
        }
        const shirtOrders = SelectedOrders[a]?.shirtorders?.map(
          (data) => data.id
        );
        if (shirtOrders && shirtOrders?.length > 0) {
          for (let i = 0; i < shirtOrders?.length; i++) {
            await dispatch(
              updateShirtOrder(shirtOrders[i], {
                isAssigned: false,
                isActive: true,
              })
            );
          }
        }
      }

      rowsToDelete?.map(async (row) => {
        await dispatch(deleteMainOrder(row));
      });
    } catch (err) {
      return Notification(
        "",
        "काहीतरी चूक झाली कृपया पुन्हा प्रयत्न करा",
        "error"
      );
    }
  };

  return (
    <BasicLayout>
      <Flex minH="80vh" w="100%" justify="center">
        <Flex
          mt={8}
          h="70vh"
          w="90%"
          marginX="auto"
          align="flex-start"
          p="5"
          direction="column"
        >
          <Flex w="100%" align="center">
            <Button
              onClick={handleDelete}
              colorScheme="facebook"
              fontWeight="bold"
              fontSize="20px"
            >
              निवडलेले हटवा
            </Button>
            <Heading my="5px" w="95%" textAlign="center" alignItems="center">
              ऑर्डर तपशील
            </Heading>
            <Input
              maxW="200px"
              onChange={(e) => setSearchTerm(e.target.value)}
              placeholder="ऑर्डर शोधा"
            ></Input>
          </Flex>

          <Flex w="100%" overflowX="scroll">
            <CustomizedTable
              column={columns}
              data={data}
              onSelectRow={selectId}
            ></CustomizedTable>
          </Flex>
        </Flex>
      </Flex>
    </BasicLayout>
  );
};

export default Order;
